import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';
import store from '@/store/index';
import '../types';
import { Characteristic, ValueDefinition } from '../types';

// KTU_MM_ABSENKDICHTUNG
export const getAbsenkdichtungLLTValue = (): ValueDefinition => {
    // debugger;
    let doorLeafTotalWidth: number = 0;
    let lltNumber: string = '0';

    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const absenkdichtung = helper.GetDependencyValueCode('CUST_MM_ABSENKDICHTUNG', contex.Measure);
    const brandschutz = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    if (absenkdichtung === 'JA') {
        if (doorWings === 'D1') {
            doorLeafTotalWidth = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE', contex.Measure); // KTU_MM_TUERBLATTBREITE_GES
        } else {
            doorLeafTotalWidth = helper.GetMainCharacteristicValue('KTU_MM_GEHFLUEGEL_BREITE', contex.Measure);
        }

        const x = doorLeafTotalWidth;
        if(brandschutz === '30')
        {
            if (x > 409 && x <= 585) {
                lltNumber = 'LLT620011';
            } else if (x > 585 && x <= 710) {
                lltNumber = 'LLT620012';
            } else if (x > 710 && x <= 771) {
                lltNumber = 'LLT620013';
            } else if (x >= 771 && x <= 821) {
                lltNumber = 'LLT620014';
            } else if (x > 821 && x <= 871) {
                lltNumber = 'LLT620015';
            } else if (x > 871 && x <= 921) {
                lltNumber = 'LLT620016';
            } else if (x > 921 && x <= 971) {
                lltNumber = 'LLT620017';
            } else if (x > 971 && x <= 1085) {
                lltNumber = 'LLT620018';
            } else if (x > 1085 && x <= 1210) {
                lltNumber = 'LLT620019';
            } else if (x > 1210 && x <= 1335) {
                lltNumber = 'LLT620020';
            } else {
                lltNumber = '0';
            }
        }else {
            if (x > 409 && x <= 585) {
                lltNumber = 'LLT620011';
            }
            else if (x > 585 && x <= 710) {
                lltNumber = 'LLT620012';
            }
            else if(x > 710 && x <= 771)
            {
                lltNumber = 'LLT620021';
            }else if(x > 771  && x <= 821)
            {
                lltNumber = 'LLT620022';
            }else if(x > 821 && x <= 871)
            {
                lltNumber = 'LLT620023';
            }else if(x > 871   && x <= 921)
            {
                lltNumber = 'LLT620027';
            }else if(x > 921   && x <= 971)
            {
                lltNumber = 'LLT620024';    
            }else if(x > 971  && x <= 1085)
            {
                lltNumber = 'LLT620025';   
            }else if(x > 1085   && x <= 1210)
            {
                lltNumber = 'LLT620026';   
            }
            else {
                lltNumber = '0';
            }
        }
    }

    const absenkdichtungCharacteristic = store.state.measureModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_ABSENKDICHTUNG')[0];
    const absenkdichtungValue: ValueDefinition = absenkdichtungCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return absenkdichtungValue;
};

// KTU_MM_ABSENKDICHTUNG2
export const getAbsenkdichtungTwoLLTValue = (): ValueDefinition => {
    let doorLeafTotalWidth: number = 0;
    let lltNumber: string = '0';

    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const absenkdichtung = helper.GetDependencyValueCode('CUST_MM_ABSENKDICHTUNG', contex.Measure);
    const brandschutz = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    if (absenkdichtung === 'JA') {
        if (doorWings === 'D2') {
            doorLeafTotalWidth = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATTBREITE_STEHFLG', contex.Measure);
            const x = doorLeafTotalWidth;
            if(brandschutz === '30')
            {
                if(x <= 409) {
                    lltNumber = 'LLT620011';
                }
                else if (x > 409 && x <= 585) {
                    lltNumber = 'LLT620011';
                } else if (x > 585 && x <= 710) {
                    lltNumber = 'LLT620012';
                } else if (x > 710 && x <= 771) {
                    lltNumber = 'LLT620013';
                } else if (x >= 771 && x <= 821) {
                    lltNumber = 'LLT620014';
                } else if (x > 821 && x <= 871) {
                    lltNumber = 'LLT620015';
                } else if (x > 871 && x <= 921) {
                    lltNumber = 'LLT620016';
                } else if (x > 921 && x <= 971) {
                    lltNumber = 'LLT620017';
                } else if (x > 971 && x <= 1085) {
                    lltNumber = 'LLT620018';
                } else if (x > 1085 && x <= 1210) {
                    lltNumber = 'LLT620019';
                } else if (x > 1210 && x <= 1335) {
                    lltNumber = 'LLT620020';
                } else {
                    lltNumber = '0';
                }
            }else {
                if(x <= 409) {
                    lltNumber = 'LLT620011';
                }
                else if (x > 409 && x <= 585) {
                    lltNumber = 'LLT620011';
                } else if (x > 585 && x <= 710) {
                    lltNumber = 'LLT620012';
                }
                else if(x > 710 && x <= 771)
                {
                    lltNumber = 'LLT620021';
                }else if(x > 771  && x <= 821)
                {
                    lltNumber = 'LLT620022';
                }else if(x > 821 && x <= 871)
                {
                    lltNumber = 'LLT620023';
                }else if(x > 871   && x <= 921)
                {
                    lltNumber = 'LLT620027';
                }else if(x > 921   && x <= 971)
                {
                    lltNumber = 'LLT620024';
                }else if(x > 971  && x <= 1085)
                {
                    lltNumber = 'LLT620025';
                }else if(x > 1085   && x <= 1210)
                {
                    lltNumber = 'LLT620026';
                }
                else {
                    lltNumber = '0';
                }
            }
        } else {
            lltNumber = '0';
        }
    }

    const absenkdichtungCharacteristic = store.state.measureModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_ABSENKDICHTUNG2')[0];
    const absenkdichtungValue: ValueDefinition = absenkdichtungCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return absenkdichtungValue;
};